import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/faculty/')({
  component: FacultyToday,
});

function FacultyToday() {
  return (
    <div className="space-y-8">
      <header>
        <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
          Today's roster
        </p>
        <h1 className="mt-2">Classes</h1>
      </header>
      <p className="text-[var(--color-ink-muted)]">
        Sprint 2 wires this to your assigned classes and attendance.
      </p>
    </div>
  );
}
